export const CREATE_CREDIT_CARD_START = 'CREATE_CREDIT_CARD_START';
export const CREATE_CREDIT_CARD_SUCCESS =
  'CREATE_CREDIT_CARD_SUCCESS';
export const CREATE_CREDIT_CARD_ERROR = 'CREATE_CREDIT_CARD_ERROR';
export const CREATE_CREDIT_CARD_END = 'CREATE_CREDIT_CARD_END';
export const CLEAR_CREATE_CREDIT_CARD_STORE =
  'CLEAR_CREATE_CREDIT_CARD_STORE';
